import { Upcoming } from '../../pages/Upcoming'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/_app/upcoming-events')({
  component: Upcoming
})